import store from '@store/store'

const VuexModuleNames = [
  'adminData',
  'aggregatedSkills',
  'auth',
  'colorTheme',
  'globalVariables',
  'notification',
  'onboarding',
  'routeHistory',
  'searchExpert',
  'serviceParams',
  'skills',
  'teamup',
  'tenant',
  'tenantDiagnose',
  'tenantParams',
  'tenantUser',
  'tenantUserDiagnose',
  'tenantUsers',
  'tenantUserSkills',
  'triggers',
  'user',
  'userSuggestions',
  'window',
];

function getModulesToInitInSwitchTenant () {
  const excludes = ['auth', 'tenantUser', 'user', 'window'];
  return VuexModuleNames.filter(elem => !excludes.includes(elem));
}

const VUEX_MODULES = Object.freeze([
  'adminData',
  'aggregatedSkills',
  'auth',
  'colorTheme',
  'globalVariables',
  'notification',
  'onboarding',
  'routeHistory',
  'searchExpert',
  'serviceParams',
  'skills',
  'teamup',
  'tenant',
  'tenantDiagnose',
  'tenantParams',
  'tenantUser',
  'tenantUserDiagnose',
  'tenantUsers',
  'tenantUserSkills',
  'triggers',
  'user',
  'userSuggestions',
  'window',
]);

async function initStore (keepAuth=false, excludes = []) {
  excludes = excludes.concat([
    'colorTheme',
    'window',
    'globalVariables',
    'serviceParams',
  ]);
  if (keepAuth) {
    excludes = excludes.concat(['auth', 'user']);
  }

  const modules = await VUEX_MODULES.filter(elem => !excludes.includes(elem));
  for (const module of modules) {
    await store.commit(`${module}/initialize`, null, { root: true });
  }
}

export {
  getModulesToInitInSwitchTenant,
  initStore,
  VuexModuleNames,
  VUEX_MODULES,
};
